module.exports = __webpack_public_path__ + "static/media/pedigree-next-ico.5a736d79.svg";